import React, { useState } from 'react';
import axios from 'axios';

export default function DeployPanel({ projectName }) {
  const [result, setResult] = useState(null);
  const [loadingAction, setLoadingAction] = useState('');

  const runAction = async (action) => {
    setLoadingAction(action);
    try {
      const res = await axios.post(`/api/projects/${encodeURIComponent(projectName)}/${action}`);
      setResult(res.data);
    } catch (err) {
      setResult({
        error: true,
        action,
        message: `${action} 接口暂未接通或执行失败`,
        detail: err.response?.data?.error || err.message
      });
    } finally {
      setLoadingAction('');
    }
  };

  return (
    <div className="p-4 text-sm">
      <h3 className="font-bold mb-3">部署打包</h3>

      <div className="bg-gray-900 rounded p-3 mb-4 text-xs text-gray-300 leading-6">
        部署必须经过：五维解构、验收检测、双模型评审、补丁回归、审计记录。
      </div>

      <div className="grid grid-cols-2 gap-2 mb-4">
        <button onClick={() => runAction('build')} className="bg-blue-600 py-2 rounded">构建</button>
        <button onClick={() => runAction('package')} className="bg-purple-600 py-2 rounded">打包</button>
        <button onClick={() => runAction('deploy')} className="bg-green-600 py-2 rounded">部署</button>
        <button onClick={() => runAction('rollback')} className="bg-red-600 py-2 rounded">回滚</button>
      </div>

      {loadingAction && <div className="text-yellow-400 mb-3">正在执行：{loadingAction}</div>}

      <pre className="bg-black text-green-400 p-3 rounded h-80 overflow-auto text-xs whitespace-pre-wrap">
        {JSON.stringify(result || {
          waiting: true,
          project: projectName,
          outputs: ['构建日志', '部署包', '回滚命令', '审计报告']
        }, null, 2)}
      </pre>
    </div>
  );
}
